import { Suspense, useEffect } from "react";
import { AppAlert, AppLoader } from "./components";
import GlobalStyle from "./theme/globalStyles";
import { ThemeProvider } from "styled-components";
import theme from "./theme";
import './i18n';
import { BrowserRouter } from "react-router-dom";
import { setWebp } from "./store/ui";
import { isIOS, isIPad13, osVersion } from "react-device-detect";
import { selectUserUuid, setUserToken, setUuid } from "./store/signup";
import useInlineScript from "./hooks/useInlineScript";
import AF from "./scripts/appsflyer";
import { useDispatch, useSelector } from "react-redux";
import RouterPath from "./RouterPath";
import { fontFaces } from "./theme/fontFaces";
import { useFontsLoader } from "./hooks/useFontsLoader";
import oneLinkSmartScript from './scripts/OneLink';
import tiktok from './scripts/tiktokPixel';
import pinterest from './scripts/pinterestPixel';
import ReactGA from "react-ga4";
import FacebookPixel from "react-facebook-pixel";
import RedditPixel from "react-reddit-pixel";
import { REACT_APP_GOOGLE_TRACKING_ID, REACT_APP_GOOGLE_ADS_ID } from "./analytics/GA";
import { FB_PIXEL_ID } from "./analytics/facebook";
import { PINA_PIXEL_ID } from "./analytics/pinterest";

function App() {
  const dispatch = useDispatch();
  const isWebp = !((isIOS && osVersion < 14) || isIPad13);
  const userUuid = useSelector(selectUserUuid);

  useFontsLoader(fontFaces);

  useInlineScript(AF, 'AppsFlyerSdkObject');
  useInlineScript(oneLinkSmartScript, 'AF_SMART_SCRIPT');
  useInlineScript(tiktok, 'TiktokJelly');
  const pinaLoad = useInlineScript(pinterest, 'pintrk');

  useEffect(() => {
    if (!userUuid) return;
    FacebookPixel.init(FB_PIXEL_ID, { external_id: userUuid });
    FacebookPixel.pageView();

    RedditPixel.init("t2_w1gr13ev", {
      optOut: false,
      useDecimalCurrencyValues: true,
      externalId: userUuid,
    });
    RedditPixel.pageVisit();

    if (pinaLoad) {
      window.pintrk('load', PINA_PIXEL_ID, { external_id: userUuid });
      window.pintrk('page');
      window.pintrk('track', 'pagevisit');
    }
  }, [userUuid, pinaLoad]);

  useEffect(() => {
    const initOptionsList = [
      { trackingId: REACT_APP_GOOGLE_TRACKING_ID },
      { trackingId: REACT_APP_GOOGLE_ADS_ID },
    ];
    if (REACT_APP_GOOGLE_TRACKING_ID && REACT_APP_GOOGLE_ADS_ID) {
      ReactGA.initialize(initOptionsList);
    }
  }, []);

  useEffect(() => {
    const storageToken = window.sessionStorage?.getItem('access_token')

    if (storageToken) {
      dispatch(setUserToken(storageToken))
    }

    dispatch(setUuid());
  }, [dispatch])

  useEffect(() => {
    dispatch(
      setWebp(isWebp)
    )
  },[dispatch, isWebp]);
  return (
    <Suspense fallback={<AppLoader />}>
      <GlobalStyle />
      <ThemeProvider theme={theme}>
        <AppLoader showMessage />
          <BrowserRouter>
            <RouterPath dispatch={dispatch} />
          </BrowserRouter>
      </ThemeProvider>
      <AppAlert />
    </Suspense>
  )
}

export default App;
